export default __webpack_public_path__ + "static/8-contactus-4f09dac119ed8472c4bab0ba08fba610.jpg";